import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MapView = ({ events, onEventClick }) => {
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleMarkerClick = (event) => {
    setSelectedEvent(event);
  };

  const handleClosePopup = () => {
    setSelectedEvent(null);
  };

  const getDifficultyLabel = (difficulty) => {
    const labels = {
      beginner: 'Başlangıç',
      intermediate: 'Orta',
      advanced: 'İleri'
    };
    return labels?.[difficulty] || 'Başlangıç';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'short'
    });
  };

  return (
    <div className="relative w-full h-[500px] md:h-[600px] lg:h-[700px] bg-muted rounded-xl overflow-hidden">
      {/* Map Container */}
      <iframe
        width="100%"
        height="100%"
        loading="lazy"
        title="Etkinlik Haritası"
        referrerPolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps?q=41.0082,28.9784&z=10&output=embed"
        className="w-full h-full"
      />
      {/* Event Markers Overlay */}
      <div className="absolute inset-0 pointer-events-none">
        {events?.map((event, index) => (
          <button
            key={event?.id}
            onClick={() => handleMarkerClick(event)}
            className="absolute pointer-events-auto"
            style={{
              left: `${20 + (index * 15) % 60}%`,
              top: `${30 + (index * 10) % 40}%`,
              transform: 'translate(-50%, -100%)'
            }}
            aria-label={`${event?.title} konumu`}
          >
            <div className="relative">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center shadow-organic-lg hover:scale-110 transition-smooth">
                <Icon name="MapPin" size={20} color="white" />
              </div>
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-2 h-2 bg-primary rounded-full" />
            </div>
          </button>
        ))}
      </div>
      {/* Event Popup */}
      {selectedEvent && (
        <div className="absolute bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 lg:w-96 bg-card rounded-xl shadow-organic-xl p-4 md:p-5 z-10">
          <button
            onClick={handleClosePopup}
            className="absolute top-3 right-3 p-1 hover:bg-muted rounded-lg transition-smooth"
            aria-label="Kapat"
          >
            <Icon name="X" size={20} />
          </button>

          <div className="flex gap-4">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden flex-shrink-0">
              <Image
                src={selectedEvent?.image}
                alt={selectedEvent?.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="text-base md:text-lg font-semibold text-foreground mb-2 line-clamp-2">
                {selectedEvent?.title}
              </h4>

              <div className="space-y-1 mb-3">
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Icon name="MapPin" size={14} />
                  <span className="text-xs md:text-sm line-clamp-1">{selectedEvent?.location}</span>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Icon name="Calendar" size={14} />
                  <span className="text-xs md:text-sm">{formatDate(selectedEvent?.date)}</span>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">
                  {getDifficultyLabel(selectedEvent?.difficulty)}
                </span>
                <span className="text-lg font-bold text-primary">₺{selectedEvent?.price}</span>
              </div>

              <button
                onClick={() => onEventClick(selectedEvent)}
                className="mt-3 w-full px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:opacity-90 transition-smooth"
              >
                Detayları Gör
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapView;